export type DBEvent = {

    name?: string
    date?: number
    place?: string
    comment?: string
}

export type DBEvents = { [key: string]: DBEvent }

export type DBTicket = {
    sector?: string
    desc?: string
    blocked?: boolean
    form?: string
    price?: number

}
export type DBTickets = { [key: string]: DBTicket }

export type DBDirection = ScanMode.EXIT | ScanMode.ENTER

export type DBScan = {
    entrance?: string
    direction: DBDirection
    timestamp: number
    user?: string | null
}

// key обязательно который генерирует RTDB, тогда записи будут отсортированы по времени и можно получить последний
export type DBScans = { [key: string]: DBScan }

export enum ScanMode {
    INFO,
    ENTER,
    EXIT
}

export type EventUsers = {
    [key: string]: {
        access: boolean,
        email: string
    }
}

export type ScanResult = {
    // Успех транзакции (вход/выход)
    blocked?: boolean
    committed: boolean
    scans: DBScans
    lastScan?: DBScan | undefined
    ticket: DBTicket
}
